import * as React from "react"
import CssBaseline from "@mui/material/CssBaseline"
import Container from "@mui/material/Container"
import axios from "axios"
import { URL } from "../config/apis"
import { useEffect } from "react"
import LoadingPage from "../components/global/LoadingPage"
import AppointmentTable from "../components/appointments/AppointmentTable"
import EmptyState from "../components/global/EmptyState"
import { TbCalendarOff } from "react-icons/tb"
import { Stack, Typography } from "@mui/material"

export default function AppointmentsPage() {
  const [loading, setLoading] = React.useState(true)
  const [appointments, setAppointments] = React.useState([])
  const [err, setErr] = React.useState(null)

  const getLeads = async () => {
    setErr(null)
    try {
      const res = await axios.get(`${URL}/calendar`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      setAppointments(res.data)
    } catch (error) {
      setErr(error.response?.data?.message || error.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    getLeads()
  }, [])

  if (loading) {
    return <LoadingPage />
  }

  if (err) {
    return <>{err}</>
  }

  if (!loading && !err && appointments?.length === 0) {
    return (
      <EmptyState
        text="You don't have any Appointments yet"
        icon={<TbCalendarOff fontSize={50} />}
      />
    )
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <Container
        maxWidth="100%"
        sx={{
          flex: 1,
          height: "100%",
          flexDirection: "column",
          display: "flex",
          width: "100%",
        }}
      >
        <Stack direction={'row'} spacing={1} py={1}>
          <div style={{height: 20, width : 20 , borderRadius: 10, backgroundColor: '#dcfc6f', border: '2px solid'}} />
          <Typography variant="body1" fontWeight={600} >Pick up</Typography>
        </Stack>
        <AppointmentTable appointments={appointments} />
      </Container>
    </React.Fragment>
  )
}
